export const headers = [
  { text: 'Tên xe tuyến', value: 'stt', width: '120px' },
  { text: 'Biển số xe', value: 'licensePlate', width: '150px' },
  { text: 'Đăng kí xe', value: 'carRegistration', width: '150px' },
  { text: 'Đăng kiểm', value: 'inspection', width: '150px' },

  { text: 'Tên tài xế', value: 'driver', width: '150px' },
  { text: 'CCCD', value: 'cccd', width: '150px' },
  { text: 'Giấy phép lái xe', value: 'driverLicense', width: '150px' },
  { text: 'Sơ yếu lý lịch', value: 'resume', width: '150px' },
  { text: 'Giấy khám sức khỏe', value: 'healthCertificate', width: '150px' },

  {
    text: 'GCN tập huấn nghiệp vụ lái xe KDVT',
    value: 'certificateTransportDriver',
    width: '230px'
  },
  { text: 'CN bảo hiểm bắt buộc', value: 'insuranceCertificate', width: '150px' },
  { text: 'GCN hộ kinh doanh cá thể', value: 'certificateHousehold', width: '150px' },
  { text: 'Giấy phép KDVT bằng ô tô', value: 'motorLicense', width: '150px' },
  { text: 'Ghi chú', value: 'note', width: '200px' },
  { text: 'Hành động', value: 'action', width: '100px' }
]

export const headersExcel = [
  { text: 'Tên xe tuyến', value: 'stt' },
  { text: 'Biển số xe', value: 'licensePlate' },
  { text: 'Đăng kí xe', value: 'carRegistration' },
  { text: 'Đăng kiểm', value: 'inspection' },

  { text: 'Tên tài xế', value: 'driver' },
  { text: 'CCCD', value: 'cccd' },
  { text: 'Giấy phép lái xe', value: 'driverLicense' },
  { text: 'Sơ yếu lý lịch', value: 'resume' },
  { text: 'Giấy khám sức khỏe', value: 'healthCertificate' },

  {
    text: 'GCN tập huấn nghiệp vụ lái xe KDVT',
    value: 'certificateTransportDriver'
  },
  { text: 'CN bảo hiểm bắt buộc', value: 'insuranceCertificate' },
  { text: 'GCN hộ kinh doanh cá thể', value: 'certificateHousehold' },
  { text: 'Giấy phép KDVT bằng ô tô', value: 'motorLicense' },
  { text: 'Ghi chú', value: 'note' }
]

export const dataExcel = [
  {
    stt: '1',
    licensePlate: '29B 60256',
    carRegistration: '20/05/2030',
    inspection: '20/05/2030',

    driver: 'Nguyen Van A',
    cccd: '20/05/2030',
    driverLicense: '20/05/2030',
    resume: 'Đủ',
    healthCertificate: 'Thiếu',

    certificateTransportDriver: '20/05/2030',
    insuranceCertificate: '20/05/2030',
    certificateHousehold: '20/05/2030',
    motorLicense: '20/05/2030',
    note: 'Ghi chú ở đây'
  }
]
